import { sudoStoreActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'
import {
  customValidationPasswords,
  userPasswordSchema,
} from '@/validation-schemas'
import { Button } from '@repo/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@repo/ui/dialog'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@repo/ui/form'
import { useFormValidator, useT } from '@repo/ui/hooks'
import { Input } from '@repo/ui/input'
import { useMemo } from 'react'

export function PasswordEditor({
  userId,
  modalHandler,
}: {
  userId: string
  modalHandler: { open: boolean; setOpen: (v: boolean) => void }
}) {
  const dispatch = useStoreDispatch()
  const { tc } = useT()

  // Required to avoid looping
  const defaultValues = useMemo(
    () => ({
      password: '',
      confirmPassword: '',
    }),
    [],
  )

  const { form, isFormValid, submit, submitOnPressMetaEnter } =
    useFormValidator({
      defaultValues,
      onSubmit: (values) => {
        modalHandler.setOpen(false)
        void dispatch(
          sudoStoreActions.user.updatePassword({
            userId,
            password: values.password,
          }),
        )
        form.reset(defaultValues) // required
      },
      schema: userPasswordSchema,
      customValidation: (values) => {
        return customValidationPasswords(
          values.password,
          values.confirmPassword,
        )
      },
    })
  return (
    <Dialog open={modalHandler.open} onOpenChange={modalHandler.setOpen}>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle>Edit User's password</DialogTitle>
          <DialogDescription>
            Make changes to the user's password here. Click update when you're
            done.
          </DialogDescription>
        </DialogHeader>
        <Form {...form}>
          <form
            onSubmit={submit}
            className="space-y-2"
            onKeyDown={submitOnPressMetaEnter}
          >
            <FormField
              control={form.control}
              name="password"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{tc('password')}</FormLabel>
                  <FormControl>
                    <Input
                      type="password"
                      placeholder={tc('password')}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="confirmPassword"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{tc('password')}</FormLabel>
                  <FormControl>
                    <Input
                      type="password"
                      placeholder={tc('password')}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <DialogFooter>
              <Button type="submit" disabled={!isFormValid}>
                {tc('update', { cfl: true })}
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  )
}
